import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withStyles from "@material-ui/core/styles/withStyles";
import Snackbar from "@material-ui/core/Snackbar";

import { GOOGLE_MAPS_KEY } from "../../config/constants";

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Button from "../../components/CustomButtons/Button.jsx";

import FooterSection from "../LandingPage/Sections/FooterSection";
import CustomNotification from "../LandingPage/Sections/CustomNotification";

import SectionMap from "./SectionMap";
import SectionContactInfo from "./SectionContactInfo";
import contactUsStyle from "../../assets/jss/material-kit-pro-react/views/contactUsStyle.jsx";

import { sendContactMessage } from "../../actions/commonActions";

class ContactUsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fullName: '',
            email: '',
            phone: '',
            subject: '',
            website: '',
            message: '',
            isFormCompleted: false,
            openNotification: false,
            messageNotification: '',
            variantNotification: '',
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }

    componentWillReceiveProps(nextProps) {
        if (!!nextProps.errors && !!nextProps.errors.message) {
            this.handleClickNotification(nextProps.errors.message, 'error');
            let errors = {};
            if (!!nextProps.errors.errors && nextProps.errors.errors.length>0) {
                for (let i=0; i<nextProps.errors.errors.length; i++) {
                    let actualField = nextProps.errors.errors[i];
                    errors[actualField.field] = actualField.message;
                }
                this.setState({ errors });
            }
        } else if (!!nextProps.commonReducer.success && !!nextProps.commonReducer.message) {
            this.handleClickNotification(nextProps.commonReducer.message, 'success');
            this.setState({ fullName: '', email: '', phone: '', subject: '', website: '', message: '', errors: {} });
        }
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    onChangeCustomInput = () => e => {
        if (!!e.target.id) {
            this.setState({ [e.target.id]: e.target.value });
        } else {
            this.handleClickNotification('Error actualizando la informacion ingresada. Por favor intenta de nuevo', 'error');
        }
    };

    onSubmit = e => {
        e.preventDefault();

        const { fullName, email, phone, subject, website, message } = this.state;

        let data = {
            fullName,
            email,
            phone: phone!=='' ? phone : 'Ninguno',
            subject,
            website: website!=='' ? website : 'Ninguno',
            message
        };

        this.props.sendContactMessage(data);
    };

    render() {
        const { classes } = this.props;
        const { errors } = this.state;

        return (
            <div>
                {/* Custom Notification */}
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                    <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                </Snackbar>
                {/* End Custom Notification */}

                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Contacto | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/contacto" />
                    <meta name="description" content="Contáctanos a través de nuestros medios oficiales, obtén información y ofertas. Arma una experiencia a tu medida." />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="dark"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 180,
                        color: "white"
                    }}
                />

                <div className={classes.bigMap}>
                    <SectionMap
                        googleMapURL={"https://maps.googleapis.com/maps/api/js?key="+GOOGLE_MAPS_KEY}
                        loadingElement={<div style={{ height: `100%` }} />}
                        containerElement={<div style={{ height: `100%`, borderRadius: "6px", overflow: "hidden" }}/>}
                        mapElement={<div style={{ height: `100%` }} />}
                    />
                </div>

                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.contactContent}>
                        <div className={classes.container}>
                            <h2 className={classes.title}>Envíanos un mensaje</h2>
                            <GridContainer>
                                {/* Contact Form */}
                                <GridItem xs={12} sm={12} md={7} lg={7}>
                                    <p>
                                        Para nosotros es muy importante atender tus inquietudes o escuchar tus sugerencias. Escríbenos y te responderemos en el menor tiempo posible
                                        <br />
                                        <br />
                                    </p>

                                    <form onSubmit={this.onSubmit}>
                                        <CustomInput
                                            id="fullName"
                                            formControlProps={{ fullWidth: true }}
                                            labelText= {!!errors.fullName ? errors.fullName : "Tu nombre *"}
                                            error = {!!errors.fullName}
                                            inputProps={{
                                                defaultValue: this.state.fullName,
                                                value: this.state.fullName,
                                                onChange: this.onChangeCustomInput(),
                                                required: true
                                            }}
                                        />
                                        <CustomInput
                                            id="email"
                                            formControlProps={{ fullWidth: true }}
                                            labelText= {!!errors.email ? errors.email : "Tu email *"}
                                            error = {!!errors.email}
                                            inputProps={{
                                                type: "email",
                                                defaultValue: this.state.email,
                                                value: this.state.email,
                                                onChange: this.onChangeCustomInput(),
                                                required: true
                                            }}
                                        />
                                        <CustomInput
                                            id="phone"
                                            formControlProps={{ fullWidth: true }}
                                            labelText= {!!errors.phone ? errors.phone : "Teléfono"}
                                            error = {!!errors.phone}
                                            inputProps={{
                                                defaultValue: this.state.phone,
                                                value: this.state.phone,
                                                onChange: this.onChangeCustomInput()
                                            }}
                                        />
                                        <CustomInput
                                            id="subject"
                                            formControlProps={{ fullWidth: true }}
                                            labelText= {!!errors.subject ? errors.subject : "Asunto *"}
                                            error = {!!errors.subject}
                                            inputProps={{
                                                defaultValue: this.state.subject,
                                                value: this.state.subject,
                                                onChange: this.onChangeCustomInput(),
                                                required: true
                                            }}
                                        />
                                        <CustomInput
                                            id="website"
                                            formControlProps={{ fullWidth: true }}
                                            labelText= {!!errors.website ? errors.website : "Sitio Web"}
                                            error = {!!errors.website}
                                            inputProps={{
                                                defaultValue: this.state.website,
                                                value: this.state.website,
                                                onChange: this.onChangeCustomInput()
                                            }}
                                        />
                                        <CustomInput
                                            id="message"
                                            formControlProps={{ fullWidth: true }}
                                            labelText= {!!errors.message ? errors.message : "Tu mensaje *"}
                                            error = {!!errors.message}
                                            inputProps={{
                                                multiline: true,
                                                rows: 6,
                                                defaultValue: this.state.message,
                                                value: this.state.message,
                                                onChange: this.onChangeCustomInput(),
                                                required: true
                                            }}
                                        />

                                        <br/>
                                        <div className={classes.textCenter}>
                                            <Button round color="success" type="submit">
                                                Enviar mensaje
                                            </Button>
                                        </div>
                                    </form>

                                </GridItem>
                                {/* End Contact Form */}

                                <GridItem xs={12} sm={12} md={5} lg={5} className={classes.mlAuto}>
                                  <SectionContactInfo classes={classes} />
                                </GridItem>

                            </GridContainer>
                        </div>
                    </div>
                </div>
                <FooterSection />
            </div>
        );
    }
}

ContactUsPage.propTypes = {
    sendContactMessage: PropTypes.func.isRequired,
    commonReducer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    commonReducer: state.commonReducer,
    errors: state.errors
});

export default connect(mapStateToProps, { sendContactMessage })( withStyles(contactUsStyle)(ContactUsPage) );



// WEBPACK FOOTER //
// ./src/views/ContactUsPage/ContactUsPage.jsx